import "./Loader.scss"; // Import the CSS file
export default function LoaderSpin({size = 40}) {
  
  return (
    <div className="dot-spinner" style={{ width: size, height: size }}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
